import { render, staticRenderFns } from "./LicenseView.vue?vue&type=template&id=c308244e&scoped=true&"
import script from "./LicenseView.vue?vue&type=script&lang=js&"
export * from "./LicenseView.vue?vue&type=script&lang=js&"
import style0 from "./LicenseView.vue?vue&type=style&index=0&id=c308244e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c308244e",
  null
  
)

export default component.exports